import { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { deleteProject, getProjects } from '../../redux/action';
import ItemListTableStorage from '../itemListTableStorage';
import ModalNoti from '../../../../components/modalNoti';
import './index.css';


const ITEM_PER_PAGE = 10;

function TableStorage({editProject}) {

	const [isShowDeletePopUp, setIsShowDeletePopUp] = useState(false);
	const [isShowFailPopUp, setIsShowFailPopUp] = useState(false);
	const [project, setProject] = useState(false);

	const [valuePage, setValuePage] = useState('');

	const dispatch = useDispatch();
	const [
    page,
    totalPage,
		totalProjects,
    projects,
    isDeletedProjectFail,
  ] = useSelector((state) => [
    state.manageStorage.page,
    state.manageStorage.totalPage,
		state.manageStorage.totalProjects,
    state.manageStorage.projects,
    state.manageStorage.isDeletedProjectFail,
  ]);

	useEffect(() => {
		if(isDeletedProjectFail){
			setIsShowFailPopUp(true);
		}

	},[isDeletedProjectFail])

	useEffect(() => {
		setValuePage(page);

	},[page])

	return (
		<div className='container' style={{minWidth: '90%'}}>
			<div className="main_table_search">
				<Table className="table_search">
					<thead>
						<tr>
							<th style={{width: '3%'}}><div className="middle">#</div></th>
							<th style={{width: '13%'}}><div className="middle">Tên dự án</div></th>
							<th style={{width: '15%'}}><div className="middle">Mô tả</div></th>
							<th style={{width: '10%'}}><div className="middle">Bộ phận</div></th>
							<th style={{width: '15%'}}><div className="middle">Mail liên hệ</div></th>
							<th style={{width: '14%'}}><div className="middle">Tên người liên hệ</div></th>
							<th style={{width: '11%'}}><div className="middle">SDT liên hệ</div></th>
							<th style={{width: '11%'}}><div className="middle">Dung lượng (GB)</div></th>
							<th style={{width: '13%'}}><div className="middle">Ngày cập nhật</div></th>

							<th>
								<div className="middle">Chi tiết /Sửa</div>
							</th>
							<th>
								<div className="middle">Xóa</div>
							</th>
						</tr>
					</thead>
					<tbody>
					{projects.map((project, index) => {
						return(
							<tr key={index}>
								<td><div className="middle">{(page * ITEM_PER_PAGE - ITEM_PER_PAGE) + index + 1}</div></td>
								<td><div className="middle">{project.account_name === '' ? '-' : project.account_name}</div></td>
								<td><div className={project.description === '' ? "middle" : ''}>{project.description === '' ? '-' : project.description}</div></td>
								<td><div className="middle">{project.department === '' ? '-' : project.department}</div></td>
								{/* <td><div className={project.manager.email === '' ? "middle" : ''}>{project.manager.email === '' ? '-' : project.manager.email}</div></td> */}
								<td><div className={project.manager.email === '' ? "middle" : ''}>{project.manager.email === '' ? '-' : project.manager.email.split("@")[0]}<span style={{wordBreak:"keep-all"}}>@{project.manager.email === '' ? '-' : project.manager.email.split("@")[1]}</span></div></td>
								<td><div className={project.manager.name === '' ? "middle" : ''}>{project.manager.name === '' ? '-' : project.manager.name}</div></td>
								<td style={{wordBreak:'inherit'}}><div className="middle">{project.manager.phone === '' ? '-' : project.manager.phone}</div></td>
								<td><div className="middle">{project.capacity === '' ? '-' : project.capacity}</div></td>
								<td style={{wordBreak:'inherit'}}><div className="middle">{project.update_date === '' ? '-' : project.update_date}</div></td>
								<td><div className="middle"><img src="./dashboard/edit.png" alt="" onClick={() => editProject(project)}/></div></td>
								<td><div className="middle"><img src="./dashboard/delete_2.png" alt="" onClick={() => {
											setProject(project);
											setIsShowDeletePopUp(true);
										}}/></div>
								</td>
							</tr>
						)
					})}
					</tbody>
				</Table>

				<div className="row">
					<div className="col-12">
						<div className="list_table">
							{projects.map((project, index) => {
								return (
									<ItemListTableStorage
										key={index}
										project={{
											...project,
										}}
										editProject={() => editProject(project)}
										deleteProject={() => {
											setProject(project);
											setIsShowDeletePopUp(true);
										}}
									></ItemListTableStorage>
								)
							})}
						</div>
					</div>
				</div>

				<div className="noti_page">
					<div className="noti_table_storage">Vui lòng xuất report hoặc bấm nút Chi tiết/Sửa để xem đầy đủ thông tin</div>
					<div className="pagination">
						<div className="notification_result_search">{`Tìm thấy ${totalProjects} kết quả`}</div>
						{totalPage !== 1 &&
						<div className="pagination_item">
							<img 
								className={page === 1 ? 'block_page' : ''} 
								src="./dashboard/arrow_left_circle.png"
								alt=""
								onClick={() => {
									if(page !== 1)
									{
										setValuePage(page - 1);
										dispatch(getProjects({page: page - 1}));
									}
								}}
							/>
							<input 
								className="page_current"
								placeholder={page}
								value={valuePage}
								onKeyDown={(e) => {
									if (e.key === 'Enter') {
										let value = e.target.value;
										if(isNaN(value)){
											dispatch(getProjects({page: 1}));
											setValuePage(1);
										} else {
											if(value < 1){
												value = 1;
											}
											if(value > totalPage){
												value = totalPage;
											}
											dispatch(getProjects({page: Number(value)}));
											setValuePage(value);
										}
									}
								}}
								onChange={(e) => {setValuePage(e.target.value);}}
							/>
							<span>/</span>
							<p className="page_total">{totalPage}</p>
							<img 
								className={page === totalPage ? 'block_page' : ''}
								src="./dashboard/arrow_right_circle.png"
								alt="" 
								onClick={() => {
									if(page !== totalPage){
										setValuePage(page + 1);
										dispatch(getProjects({page: page + 1}));
									}
								}}
							/>
						</div>}
					</div>
				</div>
			</div>

			<ModalNoti
				show={isShowDeletePopUp}
				onHide={() => setIsShowDeletePopUp(false)}
				closeButton={false}
				content={`Bạn đang thao tác xóa storage ${project.account_name}. Bạn muốn tiếp tục?`}
				leftButton={{
					onClick: () => {
						setIsShowDeletePopUp(false);
					},
					content: "Đóng"
				}}
				rightButton={{
					onClick: () => {
						dispatch(deleteProject(project));
						setIsShowDeletePopUp(false);
					},
					content: "Xóa"
				}}
				>
			</ModalNoti>

			<ModalNoti
				show={isShowFailPopUp}
				onHide={() => setIsShowFailPopUp(false)}
				closeButton={false}
				content={"Xảy ra lỗi trong quá trình xử lý. Vui lòng thao tác lại"}
				leftButton={{
					onClick: () => {
						setIsShowFailPopUp(false);
					},
					content: "Đóng"
				}}
				rightButton={{
					onClick: () => {
						setIsShowFailPopUp(false);
						dispatch(deleteProject(project));
					},
					content: "Thử lại"
				}}
			>
			</ModalNoti>
		</div>
	);
}

export default TableStorage;